import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    en: {
        translation: {
            "hero_title": "Homes with character, <1></1> places with soul.",
            "hero_subtitle": "Carefully selected real estate in Granada.",
            "About us": "About us",
            "Up to date": "Up to date",
            "Selected properties": "Selected properties",
            "home_search_bar_text": "Search by title, description or reference...",
            "Most recent": "Most recent",
            "Title A-Z": "Title A-Z",
            "cant_find_what_youre_looking_for": "Can't find what you're looking for?",
            "home_page_cta_subtitle": "Tell us what you need and we'll let you know when we have something right for you.",
            "No results": "No results",
            "no_results_try_again": "Try with another search or tell us what you're looking for at <1>info@promonsa.net</1>",
            "Call": "Call",
            "Email": "Email",
            "about_page_text": "A professional team, dedicated to making your real estate aspirations come true, whether it's buying your dream house, finding a location for your business or investing into property. We offer a curated service based on our extensive experience, with our main goal being sharing your excicetement, and realising it.",
            "address": "address",
            "email": "email",
            "phone": "phone",
            "seo": {
                "defaultDescription": "Promociones Montosa curates distinctive homes and new developments across Granada, Spain.",
                "homeTitle": "Granada real estate agency and new developments",
                "homeDescription": "Discover curated residential developments and unique homes from Promociones Montosa across Granada, Spain.",
                "aboutTitle": "About Promociones Montosa",
                "aboutDescription": "Meet the Promociones Montosa team and learn how we deliver curated real estate developments across Granada.",
                "propertyLoadingTitle": "Loading property",
                "propertyUnavailableTitle": "Property unavailable",
                "propertyUnavailableDescription": "We could not locate the requested property at Promociones Montosa.",
                "propertyTitle": "{{title}} in Granada, Spain",
                "propertyDescriptionFallback": "Explore this exclusive Granada property presented by Promociones Montosa.",
                "loginTitle": "Private access",
                "loginDescription": "Promociones Montosa private area to manage Granada real estate listings.",
                "adminTitle": "Admin dashboard",
                "adminDescription": "Internal dashboard to manage Promociones Montosa listings.",
                "privacyTitle": "Privacy Policy",
                "privacyDescription": "Review how Promociones Montosa handles visitor privacy and data across our Granada real estate platform.",
                "termsTitle": "Terms of Use",
                "termsDescription": "Read the terms and conditions for using Promociones Montosa’s Granada real estate website."
            },
            "privacy": {
                "title": "Privacy Policy — Promociones Montosa, S.A.",
                "lastUpdated": "Last updated: October 2025",
                "sections": {
                    "introduction": {
                        "title": "1. Introduction",
                        "p1": "Promociones Montosa, S.A. (\"we\", \"our\", \"us\") operates this real estate website to showcase properties and related content.",
                        "p2": "We respect your privacy and are committed to protecting any personal data you may share with us."
                    },
                    "collection": {
                        "title": "2. Information We Collect",
                        "p1": "At this time, we do not collect, store, or process any personal information from visitors.",
                        "p2": "Users can freely browse property listings without registration, login, or data submission."
                    },
                    "cookies": {
                        "title": "3. Cookies and Tracking",
                        "p1": "Our website may use technical cookies that are strictly necessary for website functionality (e.g. language settings, page navigation).",
                        "p2": "We do not use cookies for analytics, advertising, or profiling."
                    },
                    "links": {
                        "title": "4. Links to Other Websites",
                        "p1": "Our website may contain links to external sites (e.g. property developers or map services). We are not responsible for the privacy practices of those websites."
                    },
                    "security": {
                        "title": "5. Data Security",
                        "p1": "Since no personal data is collected, we do not store or transmit any user-related information."
                    },
                    "changes": {
                        "title": "6. Changes to This Policy",
                        "p1": "We may update this policy in the future, for example if user registration or contact forms are added. Updates will be posted on this page with a new \"last updated\" date."
                    },
                    "contact": {
                        "title": "7. Contact",
                        "p1": "If you have any questions about this policy, you can contact us at:",
                        "p2": "Promociones Montosa, S.A.",
                        "p3": "Email: <email>info@promonsa.com</email>",
                        "p4": "Registered Office: [insert address], Spain"
                    }
                }
            },
            "terms": {
                "title": "Terms of Use — Promociones Montosa, S.A.",
                "lastUpdated": "Last updated: October 2025",
                "sections": {
                    "purpose": {
                        "title": "1. Purpose",
                        "p1": "This website provides information about real estate projects and related content owned or represented by Promociones Montosa, S.A."
                    },
                    "acceptance": {
                        "title": "2. Acceptance of Terms",
                        "p1": "By browsing this website, you agree to use it in accordance with these Terms of Use and all applicable Spanish laws."
                    },
                    "intellectualProperty": {
                        "title": "3. Intellectual Property",
                        "p1": "All text, images, logos, and designs on this website are the exclusive property of Promociones Montosa, S.A., unless otherwise stated. Reproduction or redistribution is prohibited without prior written consent."
                    },
                    "accuracy": {
                        "title": "4. Accuracy of Information",
                        "p1": "We strive to ensure that all property information is accurate and up to date, but we do not guarantee the completeness or accuracy of listings or prices. All content is for informational purposes only."
                    },
                    "liability": {
                        "title": "5. Liability",
                        "p1": "Promociones Montosa, S.A. is not responsible for any damages or losses arising from access, use, or inability to use this website."
                    },
                    "externalLinks": {
                        "title": "6. External Links",
                        "p1": "Links to third-party sites are provided for convenience. We are not responsible for their content or policies."
                    },
                    "modifications": {
                        "title": "7. Modifications",
                        "p1": "We reserve the right to modify these Terms of Use at any time. Continued use of the website implies acceptance of the updated terms."
                    }
                }
            },
            "footer": {
                "privacy": "Privacy Policy",
                "terms": "Terms of Use"
            },
            "meta_description": "Promociones Montosa curates distinctive homes and new developments across Granada, Spain."
        }
    },
    es: {
        translation: {
            "hero_title": "Hogares con carácter, <1></1> ubicaciones con alma.",
            "hero_subtitle": "Selección cuidada de inmuebles en Granada.",
            "About us": "Sobre nosotros",
            "Selected properties": "Listados seleccionados",
            "home_search_bar_text": "Buscar por título, descripción o referencia…",
            "Most recent": "Más recientes",
            "Title A-Z": "Título A-Z",
            "cant_find_what_youre_looking_for": "¿No ves lo que buscas?",
            "home_page_cta_subtitle": "Dinos qué necesitas y te avisamos cuando tengamos algo a medida.",
            "No results": "Sin resultados",
            "no_results_try_again": "Prueba con otra búsqueda o cuéntanos qué buscas en <1>info@promonsa.net</1>.",
            "Call": "Llamar",
            "Email": "Escribir email",
            "about_page_text": "Un equipo profesional, dedicado a hacer realidad tu deseo de hogar, de negocio o de inversión. Ofrecemos un servicio de calidad, basado en nuestra experiencia, con la intención de ilusionar a nuestros clientes en la búsqueda de su hogar o inversión.",
            "address": "dirección",
            "email": "email",
            "phone": "teléfono",
            "seo": {
                "defaultDescription": "Promociones Montosa selecciona viviendas y promociones exclusivas en Granada, España.",
                "homeTitle": "Inmobiliaria en Granada y promociones exclusivas",
                "homeDescription": "Descubre promociones residenciales seleccionadas y viviendas únicas de Promociones Montosa en Granada, España.",
                "aboutTitle": "Sobre Promociones Montosa",
                "aboutDescription": "Conoce al equipo de Promociones Montosa y descubre cómo acercamos promociones inmobiliarias de calidad en Granada.",
                "propertyLoadingTitle": "Cargando propiedad",
                "propertyUnavailableTitle": "Propiedad no disponible",
                "propertyUnavailableDescription": "No hemos podido encontrar la propiedad solicitada en Promociones Montosa.",
                "propertyTitle": "{{title}} en Granada",
                "propertyDescriptionFallback": "Descubre los detalles de esta vivienda exclusiva en Granada con Promociones Montosa.",
                "loginTitle": "Acceso privado",
                "loginDescription": "Zona privada de Promociones Montosa para gestionar las promociones inmobiliarias.",
                "adminTitle": "Panel de administración",
                "adminDescription": "Panel interno para gestionar las promociones de Promociones Montosa.",
                "privacyTitle": "Política de privacidad",
                "privacyDescription": "Consulta cómo Promociones Montosa gestiona los datos y la privacidad de los visitantes de nuestro portal inmobiliario en Granada.",
                "termsTitle": "Términos de uso",
                "termsDescription": "Lee los términos y condiciones para utilizar el sitio web inmobiliario de Promociones Montosa en Granada."
            },
            "Up to date": "Actualizado",
            "privacy": {
                "title": "Política de Privacidad — Promociones Montosa, S.A.",
                "lastUpdated": "Última actualización: octubre de 2025",
                "sections": {
                    "introduction": {
                        "title": "1. Introducción",
                        "p1": "Promociones Montosa, S.A. (\"nosotros\", \"nuestro\") opera este sitio web inmobiliario para mostrar propiedades y contenido relacionado.",
                        "p2": "Respetamos tu privacidad y estamos comprometidos a proteger cualquier dato personal que puedas compartir con nosotros."
                    },
                    "collection": {
                        "title": "2. Información que recopilamos",
                        "p1": "En este momento no recopilamos, almacenamos ni tratamos información personal de los visitantes.",
                        "p2": "Puedes navegar por los listados de propiedades libremente, sin registro, inicio de sesión ni envío de datos."
                    },
                    "cookies": {
                        "title": "3. Cookies y seguimiento",
                        "p1": "Nuestro sitio web puede utilizar cookies técnicas estrictamente necesarias para el funcionamiento del sitio (por ejemplo, configuración de idioma, navegación entre páginas).",
                        "p2": "No utilizamos cookies con fines analíticos, publicitarios ni de creación de perfiles."
                    },
                    "links": {
                        "title": "4. Enlaces a otros sitios web",
                        "p1": "Nuestro sitio web puede contener enlaces a sitios externos (por ejemplo, promotores inmobiliarios o servicios de mapas). No somos responsables de las prácticas de privacidad de esos sitios web."
                    },
                    "security": {
                        "title": "5. Seguridad de los datos",
                        "p1": "Como no se recopilan datos personales, no almacenamos ni transmitimos ninguna información relacionada con los usuarios."
                    },
                    "changes": {
                        "title": "6. Cambios en esta política",
                        "p1": "Podemos actualizar esta política en el futuro, por ejemplo si añadimos registro de usuarios o formularios de contacto. Las actualizaciones se publicarán en esta página con una nueva fecha de \"última actualización\"."
                    },
                    "contact": {
                        "title": "7. Contacto",
                        "p1": "Si tienes alguna pregunta sobre esta política, puedes contactar con nosotros en:",
                        "p2": "Promociones Montosa, S.A.",
                        "p3": "Correo electrónico: <email>info@promonsa.com</email>",
                        "p4": "Domicilio social: [insert address], España"
                    }
                }
            },
            "terms": {
                "title": "Términos de Uso — Promociones Montosa, S.A.",
                "lastUpdated": "Última actualización: octubre de 2025",
                "sections": {
                    "purpose": {
                        "title": "1. Finalidad",
                        "p1": "Este sitio web proporciona información sobre proyectos inmobiliarios y contenido relacionado propiedad o representado por Promociones Montosa, S.A."
                    },
                    "acceptance": {
                        "title": "2. Aceptación de los Términos",
                        "p1": "Al navegar por este sitio web, aceptas utilizarlo de acuerdo con estos Términos de Uso y con toda la legislación española aplicable."
                    },
                    "intellectualProperty": {
                        "title": "3. Propiedad Intelectual",
                        "p1": "Todos los textos, imágenes, logotipos y diseños de este sitio web son propiedad exclusiva de Promociones Montosa, S.A., salvo indicación contraria. Queda prohibida su reproducción o redistribución sin consentimiento previo y por escrito."
                    },
                    "accuracy": {
                        "title": "4. Exactitud de la Información",
                        "p1": "Nos esforzamos por garantizar que toda la información de las propiedades sea precisa y esté actualizada, pero no aseguramos la exhaustividad ni la exactitud de los listados o los precios. Todo el contenido tiene fines meramente informativos."
                    },
                    "liability": {
                        "title": "5. Responsabilidad",
                        "p1": "Promociones Montosa, S.A. no se hace responsable de los daños o pérdidas derivados del acceso, uso o imposibilidad de uso de este sitio web."
                    },
                    "externalLinks": {
                        "title": "6. Enlaces Externos",
                        "p1": "Los enlaces a sitios de terceros se facilitan por comodidad. No somos responsables de su contenido ni de sus políticas."
                    },
                    "modifications": {
                        "title": "7. Modificaciones",
                        "p1": "Nos reservamos el derecho de modificar estos Términos de Uso en cualquier momento. El uso continuado del sitio web implica la aceptación de los términos actualizados."
                    }
                }
            },
            "footer": {
                "privacy": "Política de Privacidad",
                "terms": "Términos de Uso"
            },
            "meta_description": "Promociones Montosa selecciona viviendas y promociones exclusivas en Granada, España."
        }
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false // react already safes from xss
        },
        detection: {
            order: ['localStorage', 'navigator'], // tries localStorage first, then browser language
            caches: ['localStorage'],             // saves user choice
        },
    });

export default i18n;
